

import React from 'react';

// Championship Background
export const ChampionshipBackground = ({ sx, ...props }) => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 360 794"
            preserveAspectRatio="xMidYMid slice"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...sx }}
            {...props}
        >
            <g clipPath="url(#clip0_295_4285)">
                <g filter="url(#filter0_f_295_4285)">
                    <circle cx="180" r="247" fill="#6B00FE" />
                </g>
                <g filter="url(#filter1_f_295_4285)">
                    <circle cx="180" cy="122" r="125" fill="#22BDFF" />
                </g>
                <circle cx="180" r="247" fill="url(#paint0_linear_295_4285)" />
                <circle cx="180" cy="122" r="125" fill="url(#paint1_linear_295_4285)" />
                <circle cx="180.5" cy="166.5" r="80.5" fill="url(#paint2_linear_295_4285)" />
            </g>
            <defs>
                <filter id="filter0_f_295_4285" x="-167" y="-347" width="694" height="694" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_295_4285" />
                </filter>
                <filter id="filter1_f_295_4285" x="-45" y="-103" width="450" height="450" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_295_4285" />
                </filter>
                <linearGradient id="paint0_linear_295_4285" x1="180" y1="-247" x2="180" y2="247" gradientUnits="userSpaceOnUse">
                    <stop offset="0.5" stopColor="#22BDFF" stopOpacity="0.1" />
                    <stop offset="1" stopColor="#22BDFF" stopOpacity="0.6" />
                </linearGradient>
                <linearGradient id="paint1_linear_295_4285" x1="180" y1="-3" x2="180" y2="247" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#22BDFF" stopOpacity="0.1" />
                    <stop offset="1" stopColor="#22BDFF" stopOpacity="0.6" />
                </linearGradient>
                <linearGradient id="paint2_linear_295_4285" x1="180.5" y1="86" x2="180.5" y2="247" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#22BDFF" stopOpacity="0.1" />
                    <stop offset="1" stopColor="#22BDFF" stopOpacity="0.6" />
                </linearGradient>
                <clipPath id="clip0_295_4285">
                    <rect width="360" height="794" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};